var IS_IPAD = navigator.userAgent.match(/iPad/i) != null,
    IS_IPHONE = !IS_IPAD && ((navigator.userAgent.match(/iPhone/i) != null) || (navigator.userAgent.match(/iPod/i) != null)),
    IS_IOS = IS_IPAD || IS_IPHONE,
    IS_ANDROID = !IS_IOS && navigator.userAgent.match(/android/i) != null,
    IS_MOBILE = IS_IOS || IS_ANDROID;

if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    if (viewportmeta) {
        viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
        document.addEventListener('gesturestart', function (){
            viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
        }, false);
    }
}

jQuery(document).ready(function($) {
	if (IS_MOBILE) {
		$('kiber_top_wrapper video').remove();
	}

	$('.hamburger-more').on('click', function() {
		$('.hamburger_menu').toggleClass('opened');
		setTimeout(function() {
		 	$('.hamburger_menu').toggleClass('shown')
		}, 250);
	});

	$('.hamburger_menu .close').on('click', function() {
		$('.hamburger_menu').toggleClass('shown');
		setTimeout(function() {
		 	$('.hamburger_menu').toggleClass('opened');
		}, 250);
	});

	var quotes = $('.kiber_claim .container span');
	var quoteIndex = -1;

	function showNextQuote() {
	    ++quoteIndex;
	    quotes.eq(quoteIndex % quotes.length)
	        .fadeIn(1000)
	        .delay(1000)
	        .fadeOut(1000, showNextQuote);
	}

	showNextQuote();

	function maximizeIframes() {
	    // Loop over every iframe on the page
	    $('.wpb_wrapper p iframe').each(function() {
	    	var default_width = $(this).attr('width');
	    	var default_height = $(this).attr('height');
	    	$(this).css({
	    		width: default_width,
	    		height: default_height
	    	});

	    	var container_with = $(this).parent().width();
	        // Get the iframe's intended aspect ratio via it's inline dimensions
	        var ratio = $(this).attr('height') / $(this).attr('width');
	        $(this).css('width', container_with);
	        // Apply a CSS height that is in correct ratio to it's current width
	        $(this).css('height', container_with * ratio);
	    });
	}

	// Apply CSS height to every iframe in correct ratio to it's current width
	function resizeIframes() {
	    // Loop over every iframe on the page
	    $('.wpb_wrapper p iframe').each(function() {
	        // Get the iframe's intended aspect ratio via it's inline dimensions
	        var ratio = $(this).attr('height') / $(this).attr('width');
	        // Apply a CSS height that is in correct ratio to it's current width
	        $(this).css('height', $(this).width() * ratio);
	    });
	}


	maximizeIframes();
	$(window).on('load', function() {
		maximizeIframes();
	});
	$(window).on('resize', function() {
		resizeIframes();
	});

	$('.vc_pagination-item a').on('show.vc.tab', function() {
		maximizeIframes();
	});
});